import { render, staticRenderFns } from "./NutritionApports.vue?vue&type=template&id=08748bc3&scoped=true"
import script from "./NutritionApports.vue?vue&type=script&lang=js"
export * from "./NutritionApports.vue?vue&type=script&lang=js"
import style0 from "./NutritionApports.vue?vue&type=style&index=0&id=08748bc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08748bc3",
  null
  
)

export default component.exports